export default function HeroCard7() {
  return (
    <>
      <section className="hp-hero le-glowHC7">

        <div className="hp-container">

          {/* LEFT SECTION */}
          <div className="hp-left fadeInUp"> {/* Dotted animated curve (SVG) */}
              <svg className="dotted-curve" viewBox="0 0 800 200" preserveAspectRatio="none" aria-hidden>
                <path className="curve" d="M0,120 C160,40 320,180 480,110 C640,40 800,140 1000,80" fill="none" stroke="#ffffff66" strokeWidth="3" strokeDasharray="6 10" strokeLinecap="round" />
              </svg>
            <h1 className="hp-title">
              Enjoy Every Single Beat <br />
              On <span className="hp-highlight">Headphone</span>
            </h1>

            <p className="hp-desc">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
              incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.
            </p>

            <button className="hp-btn btn-anim">BUY NOW</button>
            
          </div>

          {/* RIGHT SECTION */}
          <div className="hp-right fadeIn">

              {/* Responsive SVG shapes behind image */}
              <svg className="bg-shapes" viewBox="0 0 400 400" preserveAspectRatio="xMidYMid slice" aria-hidden>
                <defs>
                  <linearGradient id="g1" x1="0" x2="1">
                    <stop offset="0" stopColor="#5c27fe" stopOpacity="0.25" />
                    <stop offset="1" stopColor="#0ac27a" stopOpacity="0.12" />
                  </linearGradient>
                </defs>
                <circle cx="300" cy="100" r="120" fill="url(#g1)" />
                <rect x="20" y="220" width="140" height="120" rx="28" fill="#ffffff08" />
              </svg>

             
            {/* Concentric rings */}
            <div className="hp-ring ring1"></div>
            <div className="hp-ring ring2"></div>

            {/* Product Image */}
             <div className="zen-c7img-wrapper">
            <img
              src="https://i.postimg.cc/NjF4BFVz/red-haired-lady-eyeglasses-holds-books-shows-ok-sign-1-removebg-preview.png"
              alt="Headphones"
              className="zen-c7hero-img floatUp"
            />
              </div>
            {/* Reviews Badge */}
            <div className="hp-reviews slideInRight">
              <p>Our Reviews</p>
              <div className="hp-avatars">
                <img src="https://i.pravatar.cc/80?img=11" />
                <img src="https://i.pravatar.cc/80?img=22" />
                <img src="https://i.pravatar.cc/80?img=33" />
                <img src="https://i.pravatar.cc/80?img=44" />
                <span>+123k</span>
              </div>
            </div>

            {/* Price Card */}
            <div className="hp-price fadeInUp">
              <h3>$179 <span className="hp-badge">Save 30% Today</span></h3>
              <p>Original Price $189</p>
            </div>

          </div>

        </div>
      </section>

      <style>{`
      
.zen-c7img-wrapper {
  position: relative;margin-top:-50px;
  width: 280px;
  height: auto;overflow:hidden;
  border-radius: 150px;
  
}

.zen-c7hero-img {
  width: 100%;
  aspect-ratio: 2/3;
  object-fit: cover;
  position: relative;
 
}
/* gradient glow */
.le-glowHC7 {
  
  background: radial-gradient(
    circle at 60% 40%,
    rgba(255, 165, 100, 0.55),
    rgba(255, 165, 100, 0.1),
    rgba(255, 165, 100, 0)
  );
 
  z-index: 0;
  
}
/* ---------------- SECTION ---------------- */
.hp-hero {
  padding: 80px 0 120px;
   /* Your background wavy pattern */
  background-size: cover;
  font-family: Inter, sans-serif;
  color: #121212;
  overflow: hidden;
}

/* Container */
.hp-container {
  width: 90%;
  max-width: 1300px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  gap: 60px;
  align-items: center;
}

/* ---------------- LEFT ---------------- */
.hp-left { flex: 1; }

.hp-title {
  font-size: 58px;
  font-weight: 900;
  line-height: 1.15;
}

.hp-highlight {
  background: #000;
  color: #fff;
  padding: 4px 14px;
  border-radius: 4px;
}

.hp-desc {
  margin-top: 20px;
  width: 80%;
  color: #333;
  line-height: 1.6;
}

.hp-btn {
  margin-top: 30px;
  background: #ff6d2f;
  color: white;
  padding: 14px 38px;
  border-radius: 8px;
  border: none;
  font-size: 18px;
  cursor: pointer;
  font-weight: 700;
}

/* Hover animation */
.btn-anim {
  transition: transform .25s ease, box-shadow .25s ease;
}
.btn-anim:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 25px rgba(255,100,50,0.3);
}

/* ---------------- RIGHT ---------------- */
.hp-right {
  flex: 1;
  position: relative;
  display: flex;
  justify-content: center;
}

/* Rings */
.hp-ring {
  position: absolute;
  border-radius: 50%;
  border: 3px solid rgba(255,100,40,0.28);
  animation: ringPulse 6s ease-in-out infinite;
}

.ring1 {
  width: 380px;
  height: 380px;
  top: -20px;
}

.ring2 {
  width: 460px;
  height: 460px;
  top: -60px;
  animation-delay: -2s;
}

@keyframes ringPulse {
  0% { transform: scale(1); opacity: .8; }
  50% { transform: scale(1.06); opacity: .55; }
  100% { transform: scale(1); opacity: .8; }
}

/* Product Image */
.hp-img {
  width: 340px;
  z-index: 4;
  position: relative;
  filter: drop-shadow(0 18px 35px rgba(0,0,0,0.25));
}

/* Floating animation */
.floatUp {
  animation: floating 4s ease-in-out infinite;
}
@keyframes floating {
  0% { transform: translateY(0); }
  50% { transform: translateY(-14px); }
  100% { transform: translateY(0); }
}

/* Reviews Badge */
.hp-reviews {
  position: absolute;
  right: -40px;
  top: 10px;
  background: #fff;
  padding: 14px 20px;
  border-radius: 12px;
  box-shadow: 0 18px 35px rgba(0,0,0,0.12);
}

.hp-reviews p {
  margin: 0;
  font-weight: 700;
}

.hp-avatars {
  display: flex;
  align-items: center;
  margin-top: 6px;
}

.hp-avatars img {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  margin-left: -8px;
  border: 2px solid #fff;
}

.hp-avatars span {
  margin-left: 10px;
  font-weight: 700;
  color: #333;
}

/* Price Card */
.hp-price {
  position: absolute;
  bottom: -40px;
  left: -40px;
  background: #fff;
  padding: 18px 26px;
  border-radius: 12px;
  box-shadow: 0 18px 40px rgba(0,0,0,0.12);
}

.hp-price h3 {
  margin: 0;
  font-size: 24px;
  font-weight: 800;
}

.hp-badge {
  background: #000;
  color: #fff;
  padding: 4px 10px;
  border-radius: 6px;
  margin-left: 12px;
  font-size: 14px;
}

.hp-price p {
  margin: 6px 0 0;
  color: #444;
}

/* ---------------- ANIMATIONS ---------------- */
.fadeInUp {
  opacity: 0;
  animation: fadeUp 1s ease forwards;
}
@keyframes fadeUp {
  0% {opacity:0; transform:translateY(25px)}
  100%{opacity:1; transform:translateY(0)}
}

.fadeIn {
  opacity: 0;
  animation: fadeInAnim 1s ease forwards .2s;
}
@keyframes fadeInAnim {
  0% {opacity:0; transform:scale(.96)}
  100%{opacity:1; transform:scale(1)}
}

.slideInRight {
  opacity: 0;
  animation: slideRight 1s ease forwards .4s;
}
@keyframes slideRight {
  0% {opacity:0; transform: translateX(40px)}
  100% {opacity:1; transform: translateX(0)}
}

/* ---------------- RESPONSIVE ---------------- */
@media (max-width: 960px) {
  .hp-container {
    flex-direction: column;
    text-align: center;
  }
  .hp-right {
    margin-top: 50px;
  }
  .hp-desc {
    width: 100%;
  }
}

      `}</style>
    </>
  );
}
